<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { WarehousePath } from '@/path.js';
    export default {
        props : ['warehouse'],
        data(){
            return {
                form : {},
                base_url : process.env.VUE_APP_API_BACKEND_URL
            }
        },
        methods : {
            async save(){
                try {
                    let res = await axios.post(this.base_url + WarehousePath.Warehouses,this.form);
                    if(res.data.status){
                        this.form = {};
                        this.$bvModal.hide('add-warehouse');
                        Swal.fire('Successfull',"","success");
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        mounted(){
            if(this.warehouse){
                this.form.id = this.warehouse.id;
                this.form.name = this.warehouse.name;
            }
        }
    }
</script>

<template>
    <div>
        <b-card>
            <b-row>
                <b-col sm="12">
                    <label>Name</label>
                    <b-input v-model="form.name"></b-input>
                </b-col>
                <b-col sm="12">
                    <b-button variant="success" @click="save">Save</b-button>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<style>
    
</style>